import { z } from 'zod';

/**
 * Which tab of the Auth0 Universal Login widget opens first. Mirrors the values Auth0 accepts for its `screen_hint`
 * authorization parameter; omitting the parameter leaves Auth0 on its default login tab.
 */
export enum Auth0ScreenHint {
	Login = 'login',
	Signup = 'signup',
}

export const auth0ScreenHintSchema = z.nativeEnum(Auth0ScreenHint);
